import { IMinUserDepricated } from "@mctypes/global.types";
import { z, ZodType } from "zod";
import { IAkustikkPremissRapport } from "./akustikk/akustikkPremissrapportSchema";
import { IBrannkoseptRapport } from "./brannkonseptSchema";
import { IBygningsfysikkPremissRapport } from "./bygningsfysikk/bygningsfysikkPremissrapport/bygningsfysikkPremissrapportSchema";
import { IEksempelrapport } from "./eksempelRapportSchema";
import { IElektroSamsvarserklaringEkomnettRapport } from "./elektroSamsvarserklaringEkomnettSchema";
import { IElektroSamsvarserklaringFELRapport } from "./elektroSamsvarserklaringFELSchema";
import { IGeoTeknikkRapport } from "./geoteknikSchema";
import { IGKRapport } from "./gkReportSchema";
import { IInternJuridiskUnderkonsulentRapport } from "./internJuridiskSchema";
import { ISJArapport } from "./sjaSchema";
import { IOverleveringChecklistReport } from "./startupChecklistSchema";

export interface IReportTemplate {
  templateId?: number;
  name: string;
  description?: string;
  admin?: IMinUserDepricated;
  data: object;
  enabledForUser: boolean;
  domainsWithAccess?: string[];
  zodSchema?: ZodType;
}

export const ZReportTemplateId = z.union([
  z.literal(101),
  z.literal(102),
  z.literal(103),
  z.literal(104),
  z.literal(106),
  z.literal(201),
  z.literal(202),
  z.literal(205),
  z.literal(301),
  z.literal(401),
  z.literal(601),
  z.literal(701),
  z.literal(901),
]);

export type ReportCode = 101 | 102 | 103 | 104 | 106 | 201 | 202 | 205 | 301 | 401 | 701 | 901;

export type IReportKeyData = {
  101: IEksempelrapport | null;
  102: IBrannkoseptRapport | null;
  103: IGeoTeknikkRapport | null;
  104: IGKRapport | null;
  106: IGeoTeknikkRapport | null;
  201: IElektroSamsvarserklaringFELRapport | null;
  202: IElektroSamsvarserklaringEkomnettRapport | null;
  205: ISJArapport | null;
  301: IBygningsfysikkPremissRapport | null;
  401: IAkustikkPremissRapport | null;
  701: IInternJuridiskUnderkonsulentRapport | null;
  901: IOverleveringChecklistReport | null;
};
